angular.module('app')
  .constant('EXPORT_BTN', {
    enabled: false
  });